import { request } from '@/helpers/request';
import { sleep } from '@/helpers/utils';
import { states } from '@/stores';


async function start(add_to_path) {
	while (true) {
		const result = await request({ path: '/' + add_to_path });
		if (result.status == 200)
			break;
		await sleep(10000);
	}
}


export default async (to, from, next) => {

	if (!states.isInitialized()) {
		let add_to_path = '';
		if (to.query && to.query.__from_link) {
			add_to_path = '?__from_link=' + to.query.__from_link;
		}
		await start(add_to_path);
	}

	next();

};
